//@flow
import React from "react";
import Svg, { Path } from "react-native-svg";

type Props = {
  size: number,
  color: string
};

export default function TheValidator({ size, color }: Props) {
  return (
    <Svg viewBox="0 0 16 16" width={size} height={size}>
      <Path
        fill={color}
        d="M4.49 4.134v3.608H2.96V1.471l3.617 2.11-.77 1.321-1.317-.768zm.184 2.39V4.492L10.744 1v5.574h-1.53V3.646l-3.01 1.731V8.35L8 7.36l3.72 2.102-5.751 3.275L0 9.232l4.674-2.708zM3.037 9.241l1.637.962v-1.91l-1.637.948zM5.98 10.97l2.638-1.502-.628-.355-2.666 1.472.656.385zm3.435.282l.764 1.325-5.676 3.274.097-4.117 1.53.036-.033 1.395 3.318-1.913zm-.558-2.843h-1.53V4.19l5.344 3.111v6.973l-4.969-2.941.78-1.317 2.659 1.574V8.182l-2.284-1.33v1.556zm.918-3.143l.787-1.312L16 7.214l-3.727 2.038-.734-1.343 1.383-.756-3.147-1.888z"
      />
    </Svg>
  );
}
